import React from 'react';
import { Star, FileDown } from 'lucide-react';
const reviews = [{
  name: 'Camila R.',
  location: 'Buenos Aires',
  week: 'Semana 32',
  text: 'La primera noche que apliqué el Protocolo de Gravedad Cero dormí 5 horas seguidas. Hacía dos meses que no podía. Lloré de alivio.'
}, {
  name: 'Florencia M.',
  location: 'Córdoba',
  week: 'Semana 28',
  text: 'Pensé que tenía que dejar el mate sí o sí. El Manual del Mate Seguro me cambió la vida — sigo con mi mate de la mañana sin ardor.'
}, {
  name: 'Lucía P.',
  location: 'Rosario',
  week: 'Semana 35',
  text: 'El Semáforo del Súper me ahorró las dudas en cada compra. Es práctico, real, hecho para las marcas que tenemos acá.'
}];
export const Testimonials: React.FC = () => {
  return <section className="py-16 md:py-24 px-4 bg-cream-card" data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <div className="text-center mb-12" data-id="element-198">
          <div className="inline-flex items-center gap-2 bg-sage/10 text-sage-dark px-4 py-2 rounded-full mb-6" data-id="element-199">
            <FileDown size={16} data-id="element-200" />
            <span className="font-sans text-sm font-medium" data-id="element-201">
              Formato PDF descargable · Lo leés en tu celu o tablet
            </span>
          </div>

          <h2 className="font-serif text-3xl md:text-4xl text-earth font-bold mb-4" data-id="element-202">
            Lo que dicen otras mamás primerizas
          </h2>
          <p className="font-sans text-earth-light" data-id="element-203">
            Reseñas reales de embarazadas argentinas que ya aplicaron el método.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-204">
          {reviews.map((review, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-sm border border-terracotta/10 flex flex-col" data-id="element-205">
              <div className="flex gap-0.5 mb-4" data-id="element-206">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-terracotta text-terracotta" data-id="element-207" />)}
              </div>

              <p className="font-sans text-earth leading-relaxed mb-6 flex-grow italic" data-id="element-208">
                "{review.text}"
              </p>

              <div className="pt-4 border-t border-cream-card" data-id="element-209">
                <p className="font-sans font-bold text-earth text-sm" data-id="element-210">
                  {review.name}
                </p>
                <p className="font-sans text-earth-light text-xs" data-id="element-211">
                  {review.location} · {review.week}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};